<template>
  <svg
    class="m-0 p-0"
    width="25"
    height="25"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1668_24662)">
      <circle cx="15.3819" cy="14.3819" r="12.3819" :fill="colorProps" />
    </g>
    <path
      d="M25.1738 21.9602C24.1786 23.2461 22.9399 24.3234 21.5283 25.1305C20.1168 25.9377 18.5601 26.4589 16.9471 26.6645C15.3342 26.87 13.6965 26.7559 12.1277 26.3285C10.5588 25.9012 9.08949 25.169 7.8036 24.1738C6.51771 23.1786 5.44044 21.9399 4.63328 20.5283C3.82612 19.1168 3.30488 17.5601 3.09933 15.9471C2.89378 14.3342 3.00794 12.6965 3.4353 11.1277C3.86265 9.55881 4.59483 8.08949 5.59003 6.8036L15.3819 14.3819L25.1738 21.9602Z"
      fill="black"
      fill-opacity="0.1"
    />
    <path
      d="M15.2018 14.1411C16.0724 14.1411 16.8262 13.8289 17.4423 13.2128C18.0582 12.5968 18.3705 11.8432 18.3705 10.9725C18.3705 10.102 18.0583 9.34827 17.4422 8.73208C16.8261 8.1162 16.0723 7.80396 15.2018 7.80396C14.3311 7.80396 13.5774 8.1162 12.9615 8.73218C12.3455 9.34816 12.0331 10.1019 12.0331 10.9725C12.0331 11.8432 12.3455 12.5969 12.9615 13.2129C13.5776 13.8288 14.3314 14.1411 15.2018 14.1411H15.2018ZM13.5067 9.2773C13.9793 8.80464 14.5338 8.5749 15.2018 8.5749C15.8698 8.5749 16.4243 8.80464 16.8971 9.2773C17.3697 9.75003 17.5996 10.3046 17.5996 10.9724C17.5996 11.6405 17.3697 12.195 16.8971 12.6677C16.4243 13.1405 15.8698 13.3702 15.2018 13.3702C14.5339 13.3702 13.9795 13.1404 13.5067 12.6677C13.0339 12.1951 12.8041 11.6405 12.8041 10.9725C12.8041 10.3046 13.0339 9.75003 13.5067 9.2773ZM20.7462 17.9201C20.7284 17.6638 20.6925 17.3841 20.6396 17.0888C20.5862 16.7913 20.5175 16.5101 20.4351 16.253C20.35 15.9873 20.2345 15.725 20.0915 15.4736C19.9432 15.2126 19.769 14.9854 19.5734 14.7984C19.369 14.6028 19.1187 14.4455 18.8292 14.3307C18.5407 14.2166 18.2211 14.1588 17.8791 14.1588C17.7448 14.1588 17.6149 14.2139 17.3641 14.3772C17.1858 14.4933 17.007 14.6086 16.8276 14.7231C16.6553 14.8329 16.4218 14.9358 16.1335 15.0289C15.8521 15.12 15.5665 15.1661 15.2844 15.1661C15.0026 15.1661 14.7169 15.12 14.4354 15.0289C14.1473 14.9359 13.9138 14.833 13.7417 14.7232C13.5421 14.5956 13.3614 14.4792 13.2048 14.3771C12.9541 14.2138 12.8242 14.1587 12.69 14.1587C12.3479 14.1587 12.0283 14.2166 11.7399 14.3309C11.4507 14.4454 11.2002 14.6027 10.9956 14.7985C10.8001 14.9856 10.6258 15.2127 10.4777 15.4736C10.3349 15.725 10.2192 15.9872 10.1341 16.2531C10.0519 16.5102 9.98316 16.7913 9.92977 17.0888C9.87676 17.3837 9.84094 17.6634 9.82316 17.9204C9.80569 18.1716 9.79688 18.4331 9.79688 18.6973C9.79688 19.384 10.0152 19.9399 10.4457 20.3499C10.8708 20.7546 11.4333 20.9597 12.1175 20.9597H18.4521C19.1361 20.9597 19.6986 20.7546 20.1239 20.35C20.5545 19.9402 20.7728 19.3841 20.7728 18.6972C20.7727 18.4321 20.7638 18.1706 20.7462 17.9201ZM19.5923 19.7914C19.3114 20.0588 18.9384 20.1888 18.452 20.1888H12.1176C11.6311 20.1888 11.2581 20.0588 10.9772 19.7915C10.7017 19.5292 10.5678 19.1712 10.5678 18.6973C10.5678 18.4507 10.576 18.2074 10.5923 17.9737C10.6081 17.7444 10.6405 17.4926 10.6886 17.225C10.7361 16.9607 10.7965 16.7127 10.8683 16.4882C10.9373 16.2729 11.0314 16.0597 11.148 15.8544C11.2593 15.6586 11.3874 15.4907 11.5287 15.3554C11.6609 15.2289 11.8275 15.1253 12.0238 15.0476C12.2054 14.9757 12.4094 14.9364 12.631 14.9304C12.6579 14.9448 12.706 14.9722 12.7839 15.023C12.9424 15.1263 13.1251 15.2441 13.327 15.3731C13.5547 15.5182 13.8479 15.6493 14.1983 15.7624C14.5566 15.8782 14.9219 15.9371 15.2845 15.9371C15.6472 15.9371 16.0126 15.8782 16.3707 15.7625C16.7213 15.6492 17.0145 15.5182 17.2425 15.3729C17.4492 15.2408 17.6267 15.1264 17.7852 15.023C17.8631 14.9723 17.9111 14.9448 17.9382 14.9305C18.1598 14.9364 18.3638 14.9757 18.5455 15.0476C18.7417 15.1253 18.9083 15.229 19.0405 15.3554C19.1818 15.4906 19.3099 15.6586 19.4212 15.8545C19.5379 16.0597 19.6321 16.273 19.7009 16.4881C19.7729 16.7129 19.8334 16.9608 19.8808 17.2249C19.9288 17.493 19.9613 17.745 19.9772 17.9738V17.974C19.9935 18.2067 20.0018 18.45 20.0019 18.6973C20.0018 19.1713 19.8679 19.5293 19.5924 19.7914H19.5923Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_1668_24662"
        x="0.286432"
        y="0.190955"
        width="28.3837"
        height="28.3819"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.904523" />
        <feGaussianBlur stdDeviation="0.904523" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1668_24662"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1668_24662"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    colorProps: String,
  },
};
</script>
